
<template>
    <div class="flex-grow-1-scroll h-100 no-gutters provider-content" ref="container">
		<div class='d-flex flex-column h-100'>
			<loading ref="loading"></loading>
			<header class="p-2 header__dashboard--top" style="z-index: 100;">
				<h1 class="h2" style="">{{ $t('translations.news_and_updates') }} <span class="h6 pt-2 pr-3 float-right text-secondary">{{ $t('translations.version') }}: <a :href='$root.getAppVersionLink()' target="_blank" style="text-decoration:underline;">{{$root.getAppVersion()}}</a></span></h1>
			</header>

            <div class="m-3">
                <template v-for='item in items.data'>
                    <div :key="item.id" class="card card-default mb-3">
                        <div class="card-header">
                            <h3 class="d-flex m-0">{{item.title}} <span class="news-time-stamp ml-auto h5">{{item.updated_at | formatDate}}</span></h3>
                        </div>
                        <div class="card-body" v-html="formatContent(item.content, true)"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            items: [],
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            axios.get(this.$root.apiBase + '/news', {}).then((res) => {
                this.items = res.data;
            }).catch((error) => {
                this.handleError(error, "read");
            });
        },
    }
}
</script>
